export default __webpack_public_path__ + "static/media/mailgun.757be5f5.svg";